import {
  LabeledGroup
} from "./TQPZEPSZ.jsx";
import {
  Select
} from "./AWY7PNYH.jsx";
import {
  cn
} from "./O62HZC57.jsx";
import {
  useLocalization
} from "./E42DI7CC.jsx";

// src/Address/DisplayAddress.tsx
import { Show } from "solid-js";
var DisplayAddress = (props) => {
  return <div class={cn("w-full text-wrap", props.class)}>
      <Show when={props.address} fallback="--">
        {props.address?.streetAddress1},
        <Show when={props.address?.streetAddress2}>
          #{props.address?.streetAddress2},
        </Show>
        {props.address?.city}, {props.address?.state} {props.address?.zipCode}
      </Show>
    </div>;
};

// src/Address/types.ts
var CountryCode = /* @__PURE__ */ ((CountryCode2) => {
  CountryCode2["USA"] = "USA";
  CountryCode2["CAN"] = "CAN";
  return CountryCode2;
})(CountryCode || {});

// src/Address/LabeledAddressInput.tsx
import { useFormContext, useFormItemContext } from "@magicdoor/form";
import { createMemo as createMemo2, mergeProps, onMount } from "solid-js";

// src/Address/regions.ts
var USA = {
  name: "United States",
  code: "USA" /* USA */,
  states: [
    {
      code: "AL",
      name: "Alabama"
    },
    {
      code: "AK",
      name: "Alaska"
    },
    {
      code: "AZ",
      name: "Arizona"
    },
    {
      code: "AR",
      name: "Arkansas"
    },
    {
      code: "CA",
      name: "California"
    },
    {
      code: "CO",
      name: "Colorado"
    },
    {
      code: "CT",
      name: "Connecticut"
    },
    {
      code: "DE",
      name: "Delaware"
    },
    {
      code: "FL",
      name: "Florida"
    },
    {
      code: "GA",
      name: "Georgia"
    },
    {
      code: "HI",
      name: "Hawaii"
    },
    {
      code: "ID",
      name: "Idaho"
    },
    {
      code: "IL",
      name: "Illinois"
    },
    {
      code: "IN",
      name: "Indiana"
    },
    {
      code: "IA",
      name: "Iowa"
    },
    {
      code: "KS",
      name: "Kansas"
    },
    {
      code: "KY",
      name: "Kentucky"
    },
    {
      code: "LA",
      name: "Louisiana"
    },
    {
      code: "ME",
      name: "Maine"
    },
    {
      code: "MD",
      name: "Maryland"
    },
    {
      code: "MA",
      name: "Massachusetts"
    },
    {
      code: "MI",
      name: "Michigan"
    },
    {
      code: "MN",
      name: "Minnesota"
    },
    {
      code: "MS",
      name: "Mississippi"
    },
    {
      code: "MO",
      name: "Missouri"
    },
    {
      code: "MT",
      name: "Montana"
    },
    {
      code: "NE",
      name: "Nebraska"
    },
    {
      code: "NV",
      name: "Nevada"
    },
    {
      code: "NH",
      name: "New Hampshire"
    },
    {
      code: "NJ",
      name: "New Jersey"
    },
    {
      code: "NM",
      name: "New Mexico"
    },
    {
      code: "NY",
      name: "New York"
    },
    {
      code: "NC",
      name: "North Carolina"
    },
    {
      code: "ND",
      name: "North Dakota"
    },
    {
      code: "OH",
      name: "Ohio"
    },
    {
      code: "OK",
      name: "Oklahoma"
    },
    {
      code: "OR",
      name: "Oregon"
    },
    {
      code: "PA",
      name: "Pennsylvania"
    },
    {
      code: "RI",
      name: "Rhode Island"
    },
    {
      code: "SC",
      name: "South Carolina"
    },
    {
      code: "SD",
      name: "South Dakota"
    },
    {
      code: "TN",
      name: "Tennessee"
    },
    {
      code: "TX",
      name: "Texas"
    },
    {
      code: "UT",
      name: "Utah"
    },
    {
      code: "VT",
      name: "Vermont"
    },
    {
      code: "VA",
      name: "Virginia"
    },
    {
      code: "WA",
      name: "Washington"
    },
    {
      code: "WV",
      name: "West Virginia"
    },
    {
      code: "WI",
      name: "Wisconsin"
    },
    {
      code: "WY",
      name: "Wyoming"
    }
  ]
};
var Canada = {
  name: "Canada",
  code: "CAN" /* CAN */,
  states: [
    {
      code: "AB",
      name: "Alberta"
    },
    {
      code: "BC",
      name: "British Columbia"
    },
    {
      code: "MB",
      name: "Manitoba"
    },
    {
      code: "NB",
      name: "New Brunswick"
    },
    {
      code: "NL",
      name: "Newfoundland and Labrador"
    },
    {
      code: "NS",
      name: "Nova Scotia"
    },
    {
      code: "ON",
      name: "Ontario"
    },
    {
      code: "PE",
      name: "Prince Edward Island"
    },
    {
      code: "QC",
      name: "Quebec"
    },
    {
      code: "SK",
      name: "Saskatchewan"
    },
    {
      code: "NT",
      name: "Northwest Territories"
    },
    {
      code: "NU",
      name: "Nunavut"
    },
    {
      code: "YT",
      name: "Yukon"
    }
  ]
};
var defaultRegions = [USA];

// src/Address/InputForLabelGroup.tsx
import { createMemo } from "solid-js";
var InputForLabelGroup = (props) => {
  const handleChange = (value) => {
    const trimmedValue = value.trim();
    props.onChange && props.onChange(trimmedValue);
  };
  const isInvalid = createMemo(() => !!props.hasError);
  return <input
    id={props.id}
    autocomplete="off"
    class="bg-inputbox-bg placeholder:text-auxiliary-text focus:ring-essential-colour w-full rounded-md border px-3 py-2 text-sm text-black focus:outline-none focus:ring-1"
    classList={{
      "border-red-300": isInvalid(),
      "ring-0": isInvalid()
    }}
    name={props.name}
    value={props.value || ""}
    onChange={(e) => {
      handleChange(e.target.value);
    }}
    type={props.type || "text"}
    placeholder={props.placeholder}
    onMouseDown={() => props.onClick && props.onClick(true)}
    onMouseUp={() => props.onClick && props.onClick(false)}
    disabled={props?.disabled}
  />;
};

// src/Address/LabeledAddressInput.tsx
var LabeledAddressInput = (rawProps) => {
  const props = mergeProps(
    {
      countries: defaultRegions,
      defaultCountry: "USA" /* USA */
    },
    rawProps
  );
  const { t } = useLocalization();
  const countriesOptions = createMemo2(() => {
    if (!props.countries) return [];
    return props.countries.map((region) => {
      return {
        label: region.name,
        value: region.code
      };
    });
  });
  const statesOptions = createMemo2(() => {
    const selectedCountry = props.countries?.find((region) => region.code === props.value?.country);
    if (!selectedCountry || !selectedCountry.states) return [];
    return selectedCountry.states.map((state) => {
      return {
        label: state.name,
        value: state.code
      };
    });
  });
  const handleChange = (name, value) => {
    const updatedValue = { ...props.value, [name]: value };
    props.onInput?.(updatedValue);
  };
  const errors = createMemo2(() => {
    let _errors = {};
    if (props.error) {
      try {
        _errors = JSON.parse(props.error);
      } catch {
        _errors = { streetAddress1: props.error, isValid: false };
      }
    }
    return _errors;
  });
  const setDefaultCountryToForm = () => {
    try {
      const formIns = useFormContext();
      const formItem = useFormItemContext();
      const _namePath = formItem?.formFieldName();
      if (!_namePath) return;
      const _address = formIns.getFieldValue(_namePath);
      if (!_address || !_address.country) {
        formIns.setFieldValue(_namePath, {
          ..._address,
          country: props.defaultCountry
        });
      }
    } catch (error) {
    }
  };
  onMount(() => {
    if (props.defaultCountry) {
      setDefaultCountryToForm();
    }
  });
  return <>
      <LabeledGroup
    required={props.required}
    label={t("Street address")}
    labelJSX={props.labelJSX}
    class={props.class}
    error={errors().streetAddress1 || errors().streetAddress2}
  >
        <div class="flex flex-col gap-2">
          <InputForLabelGroup
    id={`${props.id}-streetAddress1`}
    hasError={!!errors()?.streetAddress1}
    value={props.value?.streetAddress1}
    name="streetAddress1"
    onChange={(value) => handleChange("streetAddress1", value)}
    type={props.type}
    onClick={props.onClick}
    placeholder={t("Street address")}
    disabled={props?.disabled}
  />
          <InputForLabelGroup
    id={`${props.id}-streetAddress2`}
    name="streetAddress2"
    hasError={!!errors()?.streetAddress2}
    value={props.value?.streetAddress2}
    onChange={(value) => handleChange("streetAddress2", value)}
    type={props.type}
    placeholder={t("Unit or suite number")}
    onClick={props.onClick}
    disabled={props?.disabled}
  />
        </div>
      </LabeledGroup>
      <div class={cn("flex flex-col gap-7 md:flex-row", props.class)}>
        <div class="w-full md:w-1/3">
          <LabeledGroup label={t("City")} error={errors().city} required={props.required}>
            <InputForLabelGroup
    id={`${props.id}-city`}
    name="city"
    hasError={!!errors()?.city}
    value={props.value?.city}
    onChange={(value) => handleChange("city", value)}
    type={props.type || "text"}
    placeholder={t("City")}
    onClick={props.onClick}
    disabled={props?.disabled}
  />
          </LabeledGroup>
        </div>
        <div class="w-full md:w-1/3">
          <LabeledGroup label={t("State")} error={errors().state} required={props.required}>
            <Select
    id={`${props.id}-state`}
    filterable
    freeInput
    value={props.value?.state ?? void 0}
    options={statesOptions()}
    placeholder={t("State")}
    onChange={(value) => handleChange("state", value)}
    disabled={props?.disabled}
    emptyDescription={t("Please select a country first")}
  />
          </LabeledGroup>
        </div>
        <div class="w-full md:w-1/3">
          <LabeledGroup label={t("Zip code")} error={errors().zipCode} required={props.required}>
            <InputForLabelGroup
    id={`${props.id}-zipCode`}
    name="zipCode"
    value={props.value?.zipCode}
    hasError={!!errors()?.zipCode}
    onChange={(value) => handleChange("zipCode", value)}
    type={props.type || "text"}
    placeholder={t("Zip code")}
    onClick={props.onClick}
    disabled={props?.disabled}
  />
          </LabeledGroup>
        </div>
      </div>
      <LabeledGroup label={t("Country")} class={props.class} error={errors().country} required={props.required}>
        <Select
    id={`${props.id}-country`}
    filterable
    freeInput
    value={props.value?.country ?? void 0}
    options={countriesOptions()}
    placeholder={t("Country")}
    onChange={(value) => handleChange("country", value)}
    disabled={props?.disabled}
  />
      </LabeledGroup>
    </>;
};

export {
  DisplayAddress,
  CountryCode,
  USA,
  Canada,
  defaultRegions,
  LabeledAddressInput
};
